const normalizeErrorText = (reason) => {
	if (!reason) return '';
	if (typeof reason === 'string') return reason;
	if (typeof reason?.message === 'string') return reason.message;
	if (typeof reason?.error?.message === 'string') return reason.error.message;
	return '';
};

export default function isIgnorableRealtimeDisconnectError(reason) {
	return normalizeErrorText(reason).trim().toLowerCase() === 'unexpected server response: not connected.';
}
